import { render, staticRenderFns } from "./JChartTabColumn.vue?vue&type=template&id=4292d693&"
import script from "./JChartTabColumn.vue?vue&type=script&lang=js&"
export * from "./JChartTabColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex})
